import {Presenter} from '../../Support/with_presenter';
import {WorkoutsService} from '../../Network/WorkoutsService';
import {loadingResponse, NetworkRequestStatus, NetworkResult} from '../../Network/NetworkResult';
import {PartialWorkout} from '../../Models/PartialWorkout';
import {WorkoutListViewModel} from '../Components/Workout/WorkoutList';
import {LeaderboardService} from '../../Network/LeaderboardService';
import {LeaderboardSuggestion} from '../../Models/LeaderboardSuggestion';
import {ReportService} from '../../Network/ReportService';
import {Report} from '../../Models/Report';

export class DashboardPresenter implements Presenter {
    public recentWorkoutsResult: NetworkResult<PartialWorkout[]> = loadingResponse();
    public leaderboardSuggestionResult: NetworkResult<LeaderboardSuggestion[]> = loadingResponse();
    public allWorkoutsResult: NetworkResult<PartialWorkout[]> = loadingResponse();

    public get numWorkouts(): number | null {
        if (this.allWorkoutsResult.status !== NetworkRequestStatus.Success) {
            return null;
        }
        return this.allWorkoutsResult.data.length;
    }

    public get allWorkoutListViewModels(): WorkoutListViewModel[] {
        if (this.allWorkoutsResult.status !== NetworkRequestStatus.Success) {
            return [];
        }

        return this.allWorkoutsResult.data.slice(0, 20).map((partialWorkout) => {
            return WorkoutListViewModel.fromPartialWorkout(partialWorkout);
        });
    }

    private _reports: NetworkResult<Report[]> = loadingResponse();
    public get reports(): NetworkResult<Report[]> {
        if (this._reports.status !== NetworkRequestStatus.Success) {
            return this._reports;
        }

        return {
            status: NetworkRequestStatus.Success,
            data: this._reports.data
                .slice()
                .sort((a, b) => {
                    //Only the most recently updated reports
                    if (a.latestSnippetAt === null) {
                        return 1;
                    }
                    if (b.latestSnippetAt === null) {
                        return -1;
                    }
                    return a.latestSnippetAt.getTime() - b.latestSnippetAt.getTime();
                })
                .slice(0, 4),
        };
    }

    constructor(
        private workoutsService: WorkoutsService,
        private leaderboardService: LeaderboardService,
        private reportService: ReportService,
    ) {}

    public async mount(): Promise<void> {
        this.recentWorkoutsResult = await this.workoutsService.recent();

        await Promise.all([this.fetchAllWorkouts(), this.fetchLeaderboardSuggestions(), this.fetchReports()]);
    }

    public unmount(): void {
        /* Noop */
    }

    private async fetchAllWorkouts(): Promise<void> {
        this.allWorkoutsResult = await this.workoutsService.all();
    }

    private async fetchLeaderboardSuggestions(): Promise<void> {
        this.leaderboardSuggestionResult = await this.leaderboardService.suggestions();
    }

    private async fetchReports(): Promise<void> {
        this._reports = await this.reportService.all();
    }
}
